import { render, staticRenderFns } from "./IntegerField.vue?vue&type=template&id=0daa9d01&scoped=true"
import script from "./IntegerField.vue?vue&type=script&lang=js"
export * from "./IntegerField.vue?vue&type=script&lang=js"
import style0 from "./IntegerField.vue?vue&type=style&index=0&id=0daa9d01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daa9d01",
  null
  
)

export default component.exports